<template>
  <notifications
    :position="isMobileDevice ? 'top right' : 'bottom right'"
    :width="isMobileDevice ? '100%' : '25%'"
  >
  </notifications>
</template>

<script>
import { WINDOW_NOTIFICATION_HIDE } from '../store/mutations.type';

import { mapGetters } from 'vuex';

export default {
  name: 'NotificationToast',
  created() {
    const self = this;

    window.copyLinkToClipboard = function(elementId) {
      const text = document.getElementById(elementId);
      const selection = window.getSelection();
      const range = document.createRange();

      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);

      document.execCommand('copy');
    };

    self.$store.watch(
      () => self.$store.getters.notification,
      value => {
        if (value.message) {
          self.$notify({
            type: value.type,
            title: value.title,
            text: value.message,
            duration: value.duration,
            ignoreDuplicates: value.ignoreDuplicates
          });

          self.$store.commit(WINDOW_NOTIFICATION_HIDE);
        }
      },
      { deep: true }
    );
  },
  computed: { ...mapGetters(['isMobileDevice']) }
};
</script>
